// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"ae4dc8ee","607":"14f4762e","871":"e29bf9e4"}[chunkId] + ".chunk.js";
};